import { render } from "./OtpForm.vue?vue&type=template&id=226a9a7a&scoped=true"
import script from "./OtpForm.vue?vue&type=script&lang=js"
export * from "./OtpForm.vue?vue&type=script&lang=js"

import "./OtpForm.vue?vue&type=style&index=0&id=226a9a7a&lang=css"
import "./OtpForm.vue?vue&type=style&index=1&id=226a9a7a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226a9a7a"]])

export default __exports__